import { useTopicAuto } from "@hooks/selectors/user/support.selectors";
import { FC } from "react";
import { Text } from '@components/constructor/components';
import { fromUtcDate } from "@services/helpers";

interface SupportTopicCreateTimeProps {
    format?: string;
}

const SupportTopicCreateTime: FC<SupportTopicCreateTimeProps> = ({ format = 'lll', ...props }) => {
    const topic = useTopicAuto();

    if (!topic) {
        return null;
    }

    return (
        <Text text={fromUtcDate(topic.createTime).format(format)} {...props} />
    )
}

export default SupportTopicCreateTime;